module.exports = __webpack_public_path__ + "static/img/manual_zh_8.e092b91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_8.png
// module id = y3IK
// module chunks = 4